// window.currencyConversionRate = 88.70; // e.g., 1 USD = ₹11.03
// function formatPrice(price) {
//   // Get currency symbol
//   var currencySymbol = Shopify.currency.activeCurrencySymbol || '$';

//   // Apply conversion rate if defined
//   var conversionRate = window.currencyConversionRate || 1;
//   var convertedPrice = parseFloat(price) * conversionRate;

//   // Return formatted value
//   return (convertedPrice).toFixed(2) + ' ';
// }
// "object" == typeof Countries &&
//   (Countries.updateProvinceLabel = function (e, t) {
//     if ("string" == typeof e && Countries[e] && Countries[e].provinces) {
//       if (
//         "object" != typeof t &&
//         ((t = document.getElementById("address_province_label")), null === t)
//       )
//         return;
//       t.innerHTML = Countries[e].label;
//       var r = jQuery(t).parent();
//       r.find("select");
//       r.find(".custom-style-select-box-inner").html(Countries[e].provinces[0]);
//     }
//   }),
//   "undefined" == typeof Shopify.Cart && (Shopify.Cart = {}),
//   (Shopify.Cart.ShippingCalculator = (function () {
//     var _config = {
//         submitButton: "Calculate shipping",
//         submitButtonDisabled: "Calculating...",
//         templateId: "shipping-calculator-response-template",
//         wrapperId: "wrapper-response",
//         customerIsLoggedIn: !1,
//         moneyFormat: "${{amount}}",
//       },
//       _render = function (e) {
//         var t = jQuery("#" + _config.templateId),
//           r = jQuery("#" + _config.wrapperId);
//         if (t.length && r.length) {
//           var templateSettings = {
//             evaluate: /<%([\s\S]+?)%>/g,
//             interpolate: /<%=([\s\S]+?)%>/g,
//             escape: /<%-([\s\S]+?)%>/g
//           };
//           var compiled = _.template(jQuery.trim(t.text()));
//           var a = compiled(e);
//           if (
//             (jQuery(a).appendTo(r),
//             "undefined" != typeof Currency &&
//               "function" == typeof Currency.convertAll)
//           ) {
//             var i = "";
//             jQuery("[name=currencies]").size()
//               ? (i = jQuery("[name=currencies]").val())
//               : jQuery("#currencies span.selected").size() &&
//                 (i = jQuery("#currencies span.selected").attr("data-currency")),
//               "" !== i &&
//                 Currency.convertAll(
//                   shopCurrency,
//                   i,
//                   "#wrapper-response span.money, #estimated-shipping span.money"
//                 );
//           }
//         }
//       },
//       _enableButtons = function () {
//         jQuery(".get-rates")
//           .removeAttr("disabled")
//           .removeClass("disabled")
//           .val(_config.submitButton);
//       },
//       _disableButtons = function () {
//         jQuery(".get-rates")
//           .val(_config.submitButtonDisabled)
//           .attr("disabled", "disabled")
//           .addClass("disabled");
//       },
//       _getCartShippingRatesForDestination = function (e) {
//         var t = {
//           type: "POST",
//           url: "/cart/prepare_shipping_rates",
//           data: jQuery.param({ shipping_address: e }),
//           success: _pollForCartShippingRatesForDestination(e),
//           error: _onError,
//         };
//         jQuery.ajax(t);
//       },
//       _pollForCartShippingRatesForDestination = function (e) {
//         var t = function () {
//           jQuery.ajax("/cart/async_shipping_rates", {
//             dataType: "json",
//             success: function (r, n, a) {
//               200 === a.status
//                 ? _onCartShippingRatesUpdate(r.shipping_rates, e)
//                 : setTimeout(t, 500);
//             },
//             error: _onError,
//           });
//         };
//         return t;
//       },
//       _fullMessagesFromErrors = function (e) {
//         var t = [];
//         return (
//           jQuery.each(e, function (e, r) {
//             jQuery.each(r, function (r, n) {
//               t.push(e + " " + n);
//             });
//           }),
//           t
//         );
//       },
//       _onError = function (XMLHttpRequest, textStatus) {
//         jQuery("#estimated-shipping").hide(),
//           jQuery("#estimated-shipping em").empty(),
//           _enableButtons();
//         var feedback = "",
//           data = eval("(" + XMLHttpRequest.responseText + ")");
//         (feedback = data.message
//           ? data.message + "(" + data.status + "): " + data.description
//           : "Error : " + _fullMessagesFromErrors(data).join("; ") + "."),
//           "Error : country is not supported." === feedback &&
//             (feedback = "We do not ship to this destination."),
//           _render({ rates: [], errorFeedback: feedback, success: !1 }),
//           jQuery("#" + _config.wrapperId).show();
//       },
//       _onCartShippingRatesUpdate = function (e, t) {
//         _enableButtons();
//         var r = "";
//         if (
//           (t.zip && (r += t.zip + ", "),
//           t.province && (r += t.province + ", "),
//           (r += t.country),
//           e.length)
//         ) {
//           "0.00" == e[0].price
//             ? jQuery("#estimated-shipping em").html("FREE")
//             : jQuery("#estimated-shipping em").html(_formatRate(e[0].price));
//           for (var n = 0; n < e.length; n++)
//             e[n].convertedPrice = formatPrice(e[n].price);// Add the formatted price
//         }
//         _render({ rates: e, address: r, success: !0 }),
//           jQuery("#" + _config.wrapperId + ", #estimated-shipping").fadeIn();
//       },
//       _formatRate = function (e) {
//         function t(e, t) {
//           return "undefined" == typeof e ? t : e;
//         }
//         function r(e, r, n, a) {
//           if (
//             ((r = t(r, 2)),
//             (n = t(n, ",")),
//             (a = t(a, ".")),
//             isNaN(e) || null == e)
//           )
//             return 0;
//           e = (e / 100).toFixed(r);
//           var i = e.split("."),
//             o = i[0].replace(/(d)(?=(ddd)+(?!d))/g, "$1" + n),
//             s = i[1] ? a + i[1] : "";
//           return o + s;
//         }
//         if ("function" == typeof Shopify.formatMoney)
//           return Shopify.formatMoney(e, _config.moneyFormat);
//         "string" == typeof e && (e = e.replace(".", ""));
//         var n = "",
//           a = /{{s*(w+)s*}}/,
//           i = _config.moneyFormat;
//         switch (i.match(a)) {
//           case "amount":
//             n = r(e, 2);
//             break;
//           case "amount_no_decimals":
//             n = r(e, 0);
//             break;
//           case "amount_with_comma_separator":
//             n = r(e, 2, ".", ",");
//             break;
//           case "amount_no_decimals_with_comma_separator":
//             n = r(e, 0, ".", ",");
//         }
//         return i.replace(a, n);
//       };
//     return (
//       (_init = function () {
//         new Shopify.CountryProvinceSelector(
//           "address_country",
//           "address_province",
//           { hideElement: "address_province_container" }
//         );
//         var e = jQuery("#address_country"),
//           t = jQuery("#address_province_label").get(0);
//         "undefined" != typeof Countries &&
//           (Countries.updateProvinceLabel(e.val(), t),
//           e.change(function () {
//             Countries.updateProvinceLabel(e.val(), t);
//           })),
//           jQuery(".get-rates").click(function () {
//             _disableButtons(),
//               jQuery("#" + _config.wrapperId)
//                 .empty()
//                 .hide();
//             var e = {};
//             (e.zip = jQuery("#address_zip").val() || ""),
//               (e.country = jQuery("#address_country").val() || ""),
//               (e.province = jQuery("#address_province").val() || ""),
//               _getCartShippingRatesForDestination(e);
//           }),
//           _config.customerIsLoggedIn &&
//             jQuery(".get-rates:eq(0)").trigger("click");
//       }),
//       {
//         show: function (e) {
//           (e = e || {}),
//             jQuery.extend(_config, e),
//             jQuery(function () {
//               _init();
//             });
//         },
//         getConfig: function () {
//           return _config;
//         },
//         formatRate: function (e) {
//           return _formatRate(e);
//         },
//       }
//     );
// })());
// if (typeof Currency !== "undefined" && Currency.convertAll) {
//   Currency.convertAll(shopCurrency, Shopify.currency.active, "#wrapper-response span.money");
// }
// document.querySelector('.get-rates').addEventListener('click', function() {
//   // Get values from address fields
//   var country = document.getElementById('address_country').value;
//   var state = document.getElementById('address_province').value;
//   var zip = document.getElementById('address_zip').value;

//   // Assign values to selected fields
//   document.getElementById('selectedCountry').value = country;
//   document.getElementById('selectedState').value = state;
//   document.getElementById('selectedZipCode').value = zip;
// });

// Shopify.Cart.ShippingCalculator.show( {
//   submitButton: theme.strings.shippingCalcSubmitButton,
//   submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
//   customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
//   moneyFormat: theme.strings.shippingCalcMoneyFormat
// } );

// if(typeof Countries==='object'){Countries.updateProvinceLabel=function(country,provinceLabelElement){if(typeof country==='string'&&Countries[country]&&Countries[country].provinces){if(typeof provinceLabelElement!=='object'){provinceLabelElement=document.getElementById('address_province_label');if(provinceLabelElement===null)return}
// provinceLabelElement.innerHTML=Countries[country].label;var provinceContainer=jQuery(provinceLabelElement).parent();var provinceSelect=provinceContainer.find('select');provinceContainer.find('.custom-style-select-box-inner').html(Countries[country].provinces[0])}}}
// if(typeof Shopify.Cart==='undefined'){Shopify.Cart={}}
// Shopify.Cart.ShippingCalculator=(function(){var _config={submitButton:'Calculate shipping',submitButtonDisabled:'Calculating...',templateId:'shipping-calculator-response-template',wrapperId:'wrapper-response',customerIsLoggedIn:!1,moneyFormat:'${{amount}}'};var _render=function(response){var template=jQuery('#'+_config.templateId);var wrapper=jQuery('#'+_config.wrapperId);if(template.length&&wrapper.length){_.templateSettings={evaluate:/<%([\s\S]+?)%>/g,interpolate:/<%=([\s\S]+?)%>/g,escape:/<%-([\s\S]+?)%>/g};var myTemplate=_.template(jQuery.trim(template.text()));var compiled=myTemplate(response);jQuery(compiled).appendTo(wrapper);if(typeof Currency!=='undefined'&&typeof Currency.convertAll==='function'){var newCurrency='';var shopCurrency=$('body').data('shop-currency');if($(window).width()>=798){var $currencySelector=$(".top_bar [data-currency-converter]")}else{var $currencySelector=$("#mobile_menu [data-currency-converter]")}
// if($currencySelector.length){newCurrency=$currencySelector.val()}
// if(newCurrency!==''){Currency.convertAll(shopCurrency,newCurrency,'#wrapper-response span.money, #estimated-shipping span.money',Shopify.theme_settings.currency_format);if(shopCurrency===newCurrency){applyCurrencyFormatSettings()}}else if(shopCurrency!==Shopify.currency.active){Currency.convertAll(shopCurrency,Shopify.currency.active,'#wrapper-response span.money, #estimated-shipping span.money',Shopify.theme_settings.currency_format)
// applyCurrencyFormatSettings()}else{applyCurrencyFormatSettings()}}}};var _enableButtons=function(){jQuery('.get-rates').removeAttr('disabled').removeClass('disabled').val(_config.submitButton)};var _disableButtons=function(){jQuery('.get-rates').val(_config.submitButtonDisabled).attr('disabled','disabled').addClass('disabled')};var _getCartShippingRatesForDestination=function(shippingAddress){var params={type:'POST',url:'/cart/prepare_shipping_rates',data:jQuery.param({'shipping_address':shippingAddress}),success:_pollForCartShippingRatesForDestination(shippingAddress),error:_onError}
// jQuery.ajax(params)};var _pollForCartShippingRatesForDestination=function(shippingAddress){var poller=function(){jQuery.ajax('/cart/async_shipping_rates',{dataType:'json',success:function(response,textStatus,xhr){if(xhr.status===200){_onCartShippingRatesUpdate(response.shipping_rates,shippingAddress)}else{setTimeout(poller,500)}},error:_onError})}
// return poller};var _fullMessagesFromErrors=function(errors){var fullMessages=[];jQuery.each(errors,function(attribute,messages){jQuery.each(messages,function(index,message){fullMessages.push(attribute+' '+message)})});return fullMessages};var _onError=function(XMLHttpRequest,textStatus){jQuery('#estimated-shipping').hide();jQuery('#estimated-shipping em').empty();_enableButtons();var feedback='';var data=eval('('+XMLHttpRequest.responseText+')');if(!!data.message){feedback=data.message+'('+data.status+'): '+data.description}else{feedback='Error : '+_fullMessagesFromErrors(data).join('; ')+'.'}
// if(feedback==='Error : country is not supported.')feedback='We do not ship to this destination.';_render({rates:[],errorFeedback:feedback,success:!1});jQuery('#'+_config.wrapperId).show()};var _onCartShippingRatesUpdate=function(rates,shipping_address){_enableButtons();var readable_address='';if(shipping_address.zip)readable_address+=shipping_address.zip+', ';if(shipping_address.province)readable_address+=shipping_address.province+', ';readable_address+=shipping_address.country;if(rates.length){if(rates[0].price=='0.00'){jQuery('#estimated-shipping em').html('FREE')}else{jQuery('#estimated-shipping em').html(_formatRate(rates[0].price))}
// for(var i=0;i<rates.length;i++){if(Shopify.currency.active=="JPY"){rates[i].price=rates[i].price*100}
// rates[i].price=_formatRate(rates[i].price)}}
// _render({rates:rates,address:readable_address,success:!0});jQuery('#'+_config.wrapperId+', #estimated-shipping').fadeIn()};var _formatRate=function(cents){if(typeof Shopify.formatMoney==='function'){if(Shopify.currency.active=="JPY"){cents=cents*100}
// return Shopify.formatMoney(cents,_config.moneyFormat)}
// if(typeof cents=='string'){cents=cents.replace('.','')}
// var value='';var placeholderRegex=/\{\{\s*(\w+)\s*\}\}/;var formatString=_config.moneyFormat;function defaultOption(opt,def){return(typeof opt=='undefined'?def:opt)}
// function formatWithDelimiters(number,precision,thousands,decimal){precision=defaultOption(precision,2);thousands=defaultOption(thousands,',');decimal=defaultOption(decimal,'.');if(isNaN(number)||number==null){return 0}
// number=(number/100.0).toFixed(precision);var parts=number.split('.'),dollars=parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,'$1'+thousands),cents=parts[1]?(decimal+parts[1]):'';return dollars+cents}
// switch(formatString.match(placeholderRegex)[1]){case 'amount':value=formatWithDelimiters(cents,2);break;case 'amount_no_decimals':value=formatWithDelimiters(cents,0);break;case 'amount_with_comma_separator':value=formatWithDelimiters(cents,2,'.',',');break;case 'amount_no_decimals_with_comma_separator':value=formatWithDelimiters(cents,0,'.',',');break}
// return formatString.replace(placeholderRegex,value)};_init=function(){new Shopify.CountryProvinceSelector('address_country','address_province',{hideElement:'address_province_container'});var countriesSelect=jQuery('#address_country');var addressProvinceLabelEl=jQuery('#address_province_label').get(0);if(typeof Countries!=='undefined'){Countries.updateProvinceLabel(countriesSelect.val(),addressProvinceLabelEl);countriesSelect.change(function(){Countries.updateProvinceLabel(countriesSelect.val(),addressProvinceLabelEl)})}
// jQuery('.get-rates').click(function(){_disableButtons();jQuery('#'+_config.wrapperId).empty().hide();var shippingAddress={};shippingAddress.zip=jQuery('#address_zip').val()||'';shippingAddress.country=jQuery('#address_country').val()||'';shippingAddress.province=jQuery('#address_province').val()||'';_getCartShippingRatesForDestination(shippingAddress)});if(_config.customerIsLoggedIn){jQuery('.get-rates:eq(0)').trigger('click')}};return{show:function(params){params=params||{};jQuery.extend(_config,params);jQuery(function(){_init()})},getConfig:function(){return _config},formatRate:function(cents){return _formatRate(cents)}}})()

/**
 * Module to add a shipping rates calculator to cart page.
 *
 * Copyright (c) 2011-2016 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */
/**
 * Module to add a shipping rates calculator to cart page.
 *
 * Copyright (c) 2011-2016 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */
// window.currencyConversionRate = Shopify.currency.rate || 1; // e.g., 1 USD = ₹11.03
// function formatPrice(price) {
//   // Get currency symbol
//   var currencySymbol = Shopify.currency.activeCurrencySymbol || '$';

//   // Apply conversion rate if defined
//   var conversionRate = window.currencyConversionRate || 1;
//   var convertedPrice = parseFloat(price) * conversionRate;

//   // Return formatted value
//   return (convertedPrice).toFixed(2) + ' ';
// }

// function formatPrice(price) {
//   // Get currency symbol
//   var currencySymbol = Shopify.currency.activeCurrencySymbol || '₹';

//   // Apply conversion rate if defined
//   var conversionRate = Shopify.currency.rate || 1;
//   var convertedPrice = parseFloat(price) * conversionRate;

//   // Return formatted value
//   return (convertedPrice).toFixed(2) + ' ' + currencySymbol;
// }
(function($) {
  // Ensure jQuery exists
  if (typeof $ === 'undefined') {
    console.error('jQuery is required for Shopify Shipping Calculator.');
    return;
  }

  // -----------------------------
  // COUNTRY/PROVINCE UPDATER
  // -----------------------------
  if (typeof Countries === 'object') {
    Countries.updateProvinceLabel = function(country, provinceLabelElement) {
      if (typeof country === 'string' && Countries[country] && Countries[country].provinces) {
        if (typeof provinceLabelElement !== 'object') {
          provinceLabelElement = document.getElementById('address_province_label');
          if (!provinceLabelElement) return;
        }
        provinceLabelElement.innerHTML = Countries[country].label;
        var provinceContainer = $(provinceLabelElement).parent();
        var provinceSelect = provinceContainer.find('select');
        if (Countries[country].provinces.length) {
          provinceContainer.find('.custom-style-select-box-inner').html(Countries[country].provinces[0]);
        }
      }
    };
  }

  // -----------------------------
  // MAIN CALCULATOR LOGIC
  // -----------------------------
  if (typeof Shopify.Cart === 'undefined') Shopify.Cart = {};

  Shopify.Cart.ShippingCalculator = (function() {
    var _config = {
      submitButton: 'Calculate shipping',
      submitButtonDisabled: 'Calculating...',
      templateId: 'shipping-calculator-response-template',
      wrapperId: 'wrapper-response',
      customerIsLoggedIn: false,
      moneyFormat: '${{amount}}'
    };

    // --- Render response template ---
    var _render = function(response) {
      var template = $('#' + _config.templateId);
      var wrapper = $('#' + _config.wrapperId);
      if (template.length && wrapper.length) {
        _.templateSettings = {
          evaluate: /<%([\s\S]+?)%>/g,
          interpolate: /<%=([\s\S]+?)%>/g,
          escape: /<%-([\s\S]+?)%>/g
        };
        var myTemplate = _.template($.trim(template.text()));
        var compiled = myTemplate(response);
        wrapper.html(compiled);

        // Currency conversion (if available)
        if (typeof Currency !== 'undefined' && typeof Currency.convertAll === 'function') {
          var newCurrency = '';
          var shopCurrency = $('body').data('shop-currency');
          var $currencySelector = $(window).width() >= 798
            ? $(".top_bar [data-currency-converter]")
            : $("#mobile_menu [data-currency-converter]");

          if ($currencySelector.length) {
            newCurrency = $currencySelector.val();
          }

          if (newCurrency !== '') {
            Currency.convertAll(shopCurrency, newCurrency, '#wrapper-response span.money, #estimated-shipping span.money', Shopify.theme_settings.currency_format);
          } else if (shopCurrency !== Shopify.currency.active) {
            Currency.convertAll(shopCurrency, Shopify.currency.active, '#wrapper-response span.money, #estimated-shipping span.money', Shopify.theme_settings.currency_format);
          }
        }
      }
    };

    var _enableButtons = function() {
      $('.get-rates').prop('disabled', false).removeClass('disabled').val(_config.submitButton);
    };

    var _disableButtons = function() {
      $('.get-rates').prop('disabled', true).addClass('disabled').val(_config.submitButtonDisabled);
    };

    var _getCartShippingRatesForDestination = function(shippingAddress) {
      $.ajax({
        type: 'POST',
        url: '/cart/prepare_shipping_rates',
        data: $.param({ shipping_address: shippingAddress }),
        success: _pollForCartShippingRatesForDestination(shippingAddress),
        error: _onError
      });
    };

    var _pollForCartShippingRatesForDestination = function(shippingAddress) {
      var poller = function() {
        $.ajax('/cart/async_shipping_rates', {
          dataType: 'json',
          success: function(response, textStatus, xhr) {
            if (xhr.status === 200) {
              _onCartShippingRatesUpdate(response.shipping_rates, shippingAddress);
            } else {
              setTimeout(poller, 500);
            }
          },
          error: _onError
        });
      };
      return poller;
    };

    var _onError = function(XMLHttpRequest) {
      $('#estimated-shipping').hide().find('em').empty();
      _enableButtons();

      var feedback = '';
      try {
        var data = JSON.parse(XMLHttpRequest.responseText);
        if (data.message) {
          feedback = `${data.message} (${data.status}): ${data.description}`;
        } else {
          feedback = 'Error: ' + Object.entries(data)
            .map(([k, v]) => `${k} ${v}`).join('; ') + '.';
        }
      } catch (e) {
        feedback = 'An unexpected error occurred.';
      }

      if (feedback.includes('country is not supported')) {
        feedback = 'We do not ship to this destination.';
      }

      _render({ rates: [], errorFeedback: feedback, success: false });
      $('#' + _config.wrapperId).show();
    };

    var _onCartShippingRatesUpdate = function(rates, shipping_address) {
      _enableButtons();

      var readable_address = '';
      if (shipping_address.zip) readable_address += shipping_address.zip + ', ';
      if (shipping_address.province) readable_address += shipping_address.province + ', ';
      readable_address += shipping_address.country;

      if (rates.length) {
        var firstRate = rates[0];
        $('#estimated-shipping em').html(firstRate.price == '0.00' ? 'FREE' : _formatRate(firstRate.price));
        rates.forEach(function(rate) {
          console.log(Shopify.currency.rate,"Shopify.currency.active");
          if (Shopify.currency.active === 'JPY') rate.price = rate.price * 100;
          rate.price = _formatRate(rate.price);
        });
      }

      _render({ rates: rates, address: readable_address, success: true });
      $('#' + _config.wrapperId + ', #estimated-shipping').fadeIn();
    };

    var _formatRate = function(cents) {
      if (typeof Shopify.formatMoney === 'function') {
        if (Shopify.currency.active === 'JPY') cents = cents * 100;
        return Shopify.formatMoney(cents, _config.moneyFormat);
      }

      if (typeof cents === 'string') cents = cents.replace('.', '');
      function defaultOption(opt, def) { return (typeof opt === 'undefined' ? def : opt); }
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');
        if (isNaN(number) || number == null) return '0';
        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.');
        var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var cents = parts[1] ? (decimal + parts[1]) : '';
        return dollars + cents;
      }
      var formatString = _config.moneyFormat;
      var match = formatString.match(/\{\{\s*(\w+)\s*\}\}/);
      var value = '';
      if (match) {
        switch (match[1]) {
          case 'amount': value = formatWithDelimiters(cents, 2); break;
          case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
          case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
          case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
        }
        return formatString.replace(match[0], value);
      }
      return cents;
    };

    var _init = function() {
      new Shopify.CountryProvinceSelector('address_country', 'address_province', { hideElement: 'address_province_container' });

      var countriesSelect = $('#address_country');
      var addressProvinceLabelEl = $('#address_province_label').get(0);

      if (typeof Countries !== 'undefined') {
        Countries.updateProvinceLabel(countriesSelect.val(), addressProvinceLabelEl);
        countriesSelect.on('change', function() {
          Countries.updateProvinceLabel(countriesSelect.val(), addressProvinceLabelEl);
        });
      }

      // Use delegated event (works if button added dynamically)
      $(document).on('click', '.get-rates', function() {
        _disableButtons();
        $('#' + _config.wrapperId).empty().hide();
        var shippingAddress = {
          zip: $('#address_zip').val() || '',
          country: $('#address_country').val() || '',
          province: $('#address_province').val() || ''
        };
        _getCartShippingRatesForDestination(shippingAddress);
      });

      // Auto-calculate if customer logged in
      if (_config.customerIsLoggedIn) $('.get-rates').first().trigger('click');
    };

    return {
      show: function(params) {
        $.extend(_config, params || {});
        $(function() { _init(); });
      },
      getConfig: function() { return _config; },
      formatRate: function(cents) { return _formatRate(cents); }
    };
  })();

  // Auto-run when ready
  $(function() {
    Shopify.Cart.ShippingCalculator.show();
  });

})(jQuery);
